module.exports = __webpack_public_path__ + "img/Flags_usa.514933ff.svg";